import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import urls from "../../urls";
function calculateTotal(invoiceItems) {
  const total = invoiceItems.reduce((sum, item) => {
    return sum + item.quantity * item.price;
  }, 0);

  return total.toFixed(2); // Ensure 2 decimal places
}
function InvoiceDetailsModal({
  show,
  onClose,
  isLoading,
  supplier,
  invoiceNumber,
  invoiceDate,
  table_data,
  invoiceId,
  supplier_id,
  usePice,
}) {
  const canShowPrice = usePice === "usePrice";
  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        scrollable
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "13px" }}>
            تفاصيل الفاتورة
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          {isLoading ? (
            <div className="text-center">
              <div className="spinner-border text-dark " role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div>
              <p className="m-0">
                الفاتورة رقم : <strong>{invoiceNumber}</strong>
              </p>{" "}
              <p className="m-0">
                تاريخ الفاتورة : <strong>{invoiceDate}</strong>
              </p>
              <p className="m-0">
                الموّرد: <strong>{supplier}</strong>
              </p>
              <hr />
              <table className="table table-hover">
                <thead>
                  <tr className="text-center">
                    <th scope="col">#</th>
                    <th scope="col">التعيين</th>
                    <th scope="col"> الكمية </th>
                    {canShowPrice && (
                      <>
                        <th scope="col">سعر الوحدة </th>
                        <th scope="col">المجموع </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {table_data.map((obj, idx) => {
                    const { item_name, quantity, price } = obj;
                    return (
                      <tr className="text-center">
                        <td>{idx + 1}</td>
                        <td>{item_name}</td>
                        <td>{quantity}</td>
                        {canShowPrice && (
                          <>
                            <td>{price}</td>
                            <td>{(price * quantity).toFixed(2)} دج</td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                  {canShowPrice && (
                    <tr className="text-center table-light">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>المجموع الكلي : </td>
                      <td className="text-primary">
                        {calculateTotal(table_data)} دج{" "}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {" "}
          <a
            className="btn btn-warning "
            href={urls.printInvoiceDetails(invoiceId, supplier_id)}
            target="_blank"
            style={{ fontSize: "11px" }}
          >
            طباعة الفاتورة
          </a>
          <Button variant="primary" onClick={onClose}>
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default InvoiceDetailsModal;
{
}
